module.exports = __webpack_public_path__ + "img/tres-habitaciones-en-manhattan.359f9b50.jpg";